import React from 'react';
import { Dialog } from 'primereact/dialog';

interface FilePreviewDialogProps {
  visible: boolean;
  onHide: () => void;
  fileUrl: string | null;
  title: string;
}

const FilePreviewDialog: React.FC<FilePreviewDialogProps> = ({ visible, onHide, fileUrl, title }) => {
  return (
    <Dialog
      header={title}
      visible={visible}
      style={{ width: "90vw", height: "90vh" }}
      onHide={onHide}
      maximizable
    >
      {fileUrl && <iframe src={fileUrl} width="100%" height="100%" style={{ border: "none" }} title={title} />}
    </Dialog>
  );
};

export default FilePreviewDialog;